// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3yqds","video":"Home_video__2dPt6","videoThumb":"Home_videoThumb__2oJyM","Content":"Home_Content__1zo8D","SubContent":"Home_SubContent__1-9MO"};